import common from "../../common";
import MiniSignal from "mini-signals";

export default class ControlMethod
{
    constructor(fighter)
    {
        this.fighter = fighter;
        this.gameScene = fighter.gameScene;

        this.fireButtonPressed = false;

        this.movement = {x:0, y:0};

        this.signals = {
            on: new MiniSignal(),
            off: new MiniSignal(),
            fireProjectile: new MiniSignal()
        };
    }

    init()
    {
        this.fighter.gameScene.signalListeners.push(
            P3.input.signals.keyDown.add(this.onKeyDown, this),
            P3.input.signals.keyUp.add(this.onKeyUp, this)
        );
    }

    destroy()
    { 

    }

    update()
    {
        /*
        for(var i in common.gamepads)
        {
            for(var b in common.gamepads[i].buttons)
            {
                if(common.gamepads[i].buttons[b].touched)
                {
                    console.log('button:', common.gamepads[i].buttons[b].value);
                }
            }

            //console.log(common.gamepads[i].axis);
        }*/
    }

    onKeyDown(event)
    {
        switch (event.keyCode) {
            case P3.keys.LEFT:
                this.signals.on.dispatch('left');
            break;
            case P3.keys.RIGHT:
                this.signals.on.dispatch('right');
            break;
            case P3.keys.UP:
                this.signals.on.dispatch('up');
            break;
            case P3.keys.DOWN:
                this.signals.on.dispatch('down');
            break;
            case P3.keys.SPACE:
                if(!this.fireButtonPressed)
                {
                    this.signals.on.dispatch('fire');
                    this.fireButtonPressed = true;
                }
            break;
        }
    }

    onKeyUp(event)
    {
        switch (event.keyCode) {
            case P3.keys.LEFT:
                this.signals.off.dispatch('left');
            break;
            case P3.keys.RIGHT:
                this.signals.off.dispatch('right');
            break;
            case P3.keys.UP:
                this.signals.off.dispatch('up');
            break;
            case P3.keys.DOWN:
                this.signals.off.dispatch('down');
            break;
            case P3.keys.SPACE:
                this.signals.off.dispatch('fire');
                this.fireButtonPressed = false;
            break;
        }
    }

    isPointInsideBounds(px, py, fx, fy, bounds)
    {
        return px > fx + bounds.x && px < fx + bounds.x + bounds.width &&
               py > fy + bounds.y && py < fy + bounds.y + bounds.height;
    }
}